"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.positiveNumber = exports.positiveInteger = exports.number = exports.integer = void 0;

var _debrief = require("debrief");

var _Result = require("lemons/Result");

var _utils = require("./utils");

var anyNumber = function anyNumber(blob) {
  return typeof blob === 'number' && !Number.isNaN(blob) ? (0, _Result.Ok)(blob) : (0, _Result.Err)((0, _debrief.annotate)(blob, 'Must be number'));
};

var isInteger = function isInteger(n) {
  return Number.isInteger(n);
};

var isFinite = function isFinite(n) {
  return Number.isFinite(n);
};

var number = (0, _utils.compose)(anyNumber, (0, _utils.predicate)(isFinite, 'Number must be finite'));
exports.number = number;
var positiveNumber = (0, _utils.compose)(number, (0, _utils.predicate)(function (n) {
  return n >= 0;
}, 'Number must be positive')); // Integers

exports.positiveNumber = positiveNumber;
var integer = (0, _utils.compose)(number, (0, _utils.predicate)(isInteger, 'Number must be an integer'));
exports.integer = integer;
var positiveInteger = (0, _utils.compose)(integer, (0, _utils.predicate)(function (n) {
  return n >= 0;
}, 'Number must be positive'));
exports.positiveInteger = positiveInteger;